import React from "react";
import { Container, Card, Button, Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";

function ConfirmationPage() {
    const history = useHistory();

    return (
        <Container className="d-flex justify-content-center align-items-center min-vh-100">
            <Card className="text-center p-5 border-0" style={{ maxWidth: "400px" }}>
                <i className="mb-5 fas fa-check-circle text-success fa-8x" />

                <h1 className="fw-bold">Booking Confirmed!</h1>
                <h3 className="text-muted mb-4">
                    Your booking is successful. A confirmation email has been sent to your registered email.
                </h3>
                <div>
                    <Button href="/home" className="post-btn ">
                        Go to Home
                    </Button>

                    <Button href="/my-bookings" className="post-btn">
                        My Bookings
                    </Button>

                </div>

            </Card>
        </Container>
    );
}

export default ConfirmationPage;
